import React from "react"
import TabGroup from "@/components/ui/tab"
import styles from "../styles/login.module.scss"

interface RoleSelectionProps {
  selectedRole: number
  onRoleChange: (role: number) => void
}

const RoleSelection: React.FC<RoleSelectionProps> = ({
  selectedRole,
  onRoleChange,
}) => {
  const handleTabChange = (index: number) => {
    onRoleChange(index)
  }

  const tabs = [
    {
      label: "login.employeeLogin",
      content: null
    },
    {
      label: "login.managerLogin", 
      content: null
    }
  ]

  return (
    <div className={`${styles["user-selection"]} ${styles["login-tabs"]}`}>
      <TabGroup 
        defaultActiveTab={selectedRole}
        tabs={tabs}
        onTabChange={handleTabChange}
        orientation="horizontal"
        fullWidth={true}
      />
    </div>
  )
}

export default RoleSelection

